export default __webpack_public_path__ + "static/media/1.421d6f00.png";